// extracted by mini-css-extract-plugin
export default {"spinner":"loader_spinner__QD-y7","visible":"loader_visible__kAhkq","spin":"loader_spin__w0Z9P"};